'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$CategoriesAppPage$() {
}
export { $c_Lmealorama_AppRouter$CategoriesAppPage$ as $c_Lmealorama_AppRouter$CategoriesAppPage$ };
$p = $c_Lmealorama_AppRouter$CategoriesAppPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$CategoriesAppPage$;
/** @constructor */
function $h_Lmealorama_AppRouter$CategoriesAppPage$() {
}
export { $h_Lmealorama_AppRouter$CategoriesAppPage$ as $h_Lmealorama_AppRouter$CategoriesAppPage$ };
$h_Lmealorama_AppRouter$CategoriesAppPage$.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-1838738828);
});
$p.m = (function() {
  return "CategoriesAppPage";
});
$p.q = (function() {
  return 0;
});
$p.r = (function() {
  return "CategoriesAppPage";
});
$p.g = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
var $d_Lmealorama_AppRouter$CategoriesAppPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$CategoriesAppPage$, "mealorama.AppRouter$CategoriesAppPage$", ({
  Fn: 1,
  au: 1,
  b: 1,
  c: 1,
  a: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_AppRouter$CategoriesAppPage$ as $d_Lmealorama_AppRouter$CategoriesAppPage$ };
var $n_Lmealorama_AppRouter$CategoriesAppPage$;
function $m_Lmealorama_AppRouter$CategoriesAppPage$() {
  if ((!$n_Lmealorama_AppRouter$CategoriesAppPage$)) {
    $n_Lmealorama_AppRouter$CategoriesAppPage$ = new $c_Lmealorama_AppRouter$CategoriesAppPage$();
  }
  return $n_Lmealorama_AppRouter$CategoriesAppPage$;
}
export { $m_Lmealorama_AppRouter$CategoriesAppPage$ as $m_Lmealorama_AppRouter$CategoriesAppPage$ };
//# sourceMappingURL=mealorama.-App-Router$-Categories-App-Page$.js.map
